import React, { FC, useEffect, useState } from "react";
import Modal from "../../../../components/UI/Modal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { URLS } from "../../../../constants/url";
import Member from "../../../../components/Auth/Member";
import SignUp from "../../../../components/Auth/SignUp";
import "./auth.scss";
import { showLogin } from "../../../../store/auth/action";
import { BRANDS, COUNTRY } from "../../../../constants/app";
import MemberSignup from "../../../../components/Auth/MemberSignup";
import SignupBanner from "../../../../components/Auth/Membership/SignupBanner";

interface IAuthProps {}

const Auth: FC<IAuthProps> = () => {
  const { countryId, openModal, isLoggedIn, brandId, openSlider } = useSelector(
    (state: RootState) => ({
      countryId: state.applicationReducer.countryId,
      brandId: state.applicationReducer.brandId,
      openModal: state.authReducer.openModal,
      isLoggedIn: state.authReducer.isLoggedIn,
      openSlider: state.applicationReducer.openSlider
    })
  );

  const dispatch = useDispatch();
  const [tab, setTab] = useState("sign-in");

  useEffect(() => {
    setTab("sign-in");
  }, [openModal]);

  const onCloseModal = () => {
    dispatch(showLogin(false));
  };

  const changeTab = (type: string) => {
    setTab(type);
  };

  const onSignup = () => {
    dispatch(showLogin(true));
  };

  return (
    <Modal
      className="auth-modal"
      visible={openModal && !isLoggedIn}
      showCloseBtn={false}
    >
      <div className="modal fade show" style={{ display: "block" }}>
        <div
          className={`modal-dialog modal-dialog-centered modal-lg
          `}
        >
          <div className="modal-content">
            <button
              type="button"
              className="close-modal"
              onClick={onCloseModal}
            >
              <img
                className="close_icon"
                src={URLS.CLOSE_ICON}
                alt="close_icon"
                title="close_icon"
              />
            </button>
            <div className="modal-header">
              <div className="modal-title">
                Log in or sign up
              </div>
            </div>
            <div className="modal-body">
              <div className="col-12 auth-wrapper">
                <div className="d-flex">
                  <div
                    onClick={() => changeTab("sign-in")}
                    className={`login-tab ${tab === "sign-in" ? "active" : ""}`}
                  >
                    LOG IN
                  </div>
                  <div
                    onClick={() => changeTab("sign-up")}
                    className={`login-tab ${tab === "sign-up" ? "active" : ""}`}
                  >
                    SIGN UP
                  </div>
                </div>
                <div>
                  <div className="my-4">
                    {tab === "sign-in" ? <Member fromPage={openSlider?.type?openSlider?.type:'account'} /> : null}
                  </div>
                  <div className="my-4">
                    {tab === "sign-up" ? (
                        <SignupBanner
                          onCancel={onCloseModal}
                        />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Auth;
